import styled from 'styled-components';

export const ViewedCompaniesModalWrapper = styled.section`
  p {
    margin-bottom: 0;
  }
`;

export const ViewedCompaniesWrapper = styled.div`
  overflow-y: auto;
  height: 160px;
  margin: ${({ theme }) => theme.x3spacePx}px 0;
  border: 3px solid ${({ theme }) => theme.color.whiteRGBA(0.9)};
  > table {
    tr {
      &:last-child {
        td {
          border-bottom: transparent;
        }
      }
    }
  }
`;
